export default __webpack_public_path__ + "static/media/logo.8148b4e6.svg";